export default __webpack_public_path__ + "static/media/Chat_new.c5a90948.svg";